import request from '@/utils/request'


// 查询病种分类信息列表
export function listType(query) {
  return request({
    url: '/disease/type/list',
    method: 'get',
    params: query
  })
}

// 查询病种分类信息分页
export function pageType(query) {
  return request({
    url: '/disease/type/page',
    method: 'get',
    params: query
  })
}

// 查询病种分类信息详细
export function getType(data) {
  return request({
    url: '/disease/type/detail',
    method: 'get',
    params: data
  })
}

// 新增病种分类信息
export function addType(data) {
  return request({
    url: '/disease/type/add',
    method: 'post',
    data: data
  })
}

// 修改病种分类信息
export function updateType(data) {
  return request({
    url: '/disease/type/edit',
    method: 'post',
    data: data
  })
}

// 删除病种分类信息
export function delType(data) {
  return request({
    url: '/disease/type/delete',
    method: 'post',
    data: data
  })
}
